import { createConfirmation } from "react-confirm";
import AddRecipeListDialog from "./AddRecipeListPage";

export const showAddRecipeListDialog = createConfirmation(AddRecipeListDialog);
